module.exports = __webpack_public_path__ + "img/RA.b5573c15.png";